import { cleanCnpjOrCpf } from './document.util';
import { validateCnpj } from './index';

const MASKED_CPF = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
// CNPJ mascarado — numérico ou alfanumérico (RFB): `12.ABC.345/01DE-35`.
const MASKED_CNPJ =
  /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/i;

export function normalizeListSearch(search?: string): string {
  const value = String(search || '').trim();

  if (!value) {
    return '';
  }

  const fullDateMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (fullDateMatch) {
    const [, day, month, year] = fullDateMatch;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const partialDateMatch = value.match(/^(\d{1,2})\/(\d{1,2})$/);
  if (partialDateMatch) {
    const [, day, month] = partialDateMatch;
    return `-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const isCpfSearch = /^\d{11}$/.test(value) || MASKED_CPF.test(value);
  // CNPJ cru numérico (como antes) ou mascarado; CNPJ cru ALFANUMÉRICO só é
  // tratado como documento se o DV bater — evita transformar um texto comum de
  // 14 letras/números numa busca por documento.
  const isCnpjSearch =
    /^\d{14}$/.test(value) ||
    MASKED_CNPJ.test(value) ||
    (/^[A-Z0-9]{14}$/i.test(value) && validateCnpj(value));

  if (isCpfSearch || isCnpjSearch) {
    const document = cleanCnpjOrCpf(value);
    if (document) return document;
  }

  return value;
}
